import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  return (
    <section id="contact" className="bg-black py-24">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main CTA Card */}
        <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-white/10 to-white/[0.02] border border-white/10 p-12 md:p-16">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
          </div>

          <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center">
            {/* Left: Text */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Let's Chat
              </h2>
              <p className="text-white/60 text-lg mb-8 leading-relaxed">
                Tell us about your project and let's discuss how we can partner up. 
                We're excited to help you build something amazing.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button
                  size="lg"
                  className="bg-white text-black hover:bg-white/90 rounded-full px-8 py-6 text-lg font-medium group"
                  onClick={() => window.open('https://calendly.com/superboonie', '_blank')}
                >
                  Setup a Call
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                <Button
                  size="lg"
                  variant="outline"
                  className="border-white/30 text-white hover:bg-white/10 hover:border-white/50 rounded-full px-8 py-6 text-lg font-medium bg-white/5"
                  onClick={() => window.location.href = 'mailto:hello@tappollo.com'}
                >
                  Request Quote
                </Button>
              </div>
            </div>

            {/* Right: Contact Info */}
            <div className="space-y-6">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/10">
                <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-white/40 text-sm mb-1">Email us</p>
                  <a href="mailto:hello@tappollo.com" className="text-white hover:text-white/80 transition-colors">
                    hello@tappollo.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/10">
                <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-white/40 text-sm mb-1">Call us</p>
                  <a href="tel:+1234567890" className="text-white hover:text-white/80 transition-colors">
                    Schedule a call
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 rounded-xl bg-white/5 border border-white/10">
                <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <div>
                  <p className="text-white/40 text-sm mb-1">Location</p>
                  <p className="text-white">New York City, USA</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;